import React from "react";
import * as palette from "@govlaunch/palette";

export default function Divider({ attributes, children }) {
  return (
    <div {...attributes}>
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div
        contentEditable={false}
        css={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <hr
          css={{
            margin: 0,
            padding: 0,
            border: "none",
            width: "100%",
            borderBottom: `1px solid ${palette.lightestSealBlue}`,
          }}
        />
      </div>
    </div>
  );
}
